import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import cx from 'classnames';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

const styles = theme => ({
  input: {
    display: 'none',
  },
});

class UploadButton extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    children: PropTypes.any,
    className: PropTypes.string,
    fileInputProps: PropTypes.object,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    children: null,
    className: null,
    fileInputProps: {
      className: null,
    },
    onChange: () => {},
  };
  render() {
    const {
      name,
      classes,
      children,
      className,
      fileInputProps: { className: fileInputClassName, ...restFileInputProps },
      onChange,
      ...rest
    } = this.props;
    return (
      <React.Fragment>
        <input
          // accept="image/*,application/pdf"
          className={cx(classes.input, fileInputClassName)}
          id={`contained-button-file-${name}`}
          type="file"
          onChange={onChange}
          {...restFileInputProps}
        />
        <Box
          component="label"
          width="100%"
          htmlFor={`contained-button-file-${name}`}
        >
          <Button
            component="span"
            className={cx(classes.button, className)}
            {...rest}
          >
            {children}
          </Button>
        </Box>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(UploadButton);
